<ng-container>
    <div class="wrapper__form">
      <app-form
        [title]="' '"
        [fields]="formFieldsTipoPersona"
        [withSubmitButton]="false"
        (changeAction)="validarFormularioTipoPersona($event)"
        [idEntidad]="entidadId" />
      <br />

      <app-form
        [fields]="formFieldsDemandanteNatural"
        *ngIf="formTipoPersona.value?.tipoPersona == '1' && mostrarFormulario"
        [title]="comunText['demandante-natural']"
        [withSubmitButton]="false"
        (changeAction)="validarFormularioDemandante($event)"
        (changedControl)="onChangeValidarFormulario($event)"
        [idEntidad]="entidadId" />

      <app-form
        [fields]="formFieldsDemandanteJuridica"
        *ngIf="formTipoPersona.value?.tipoPersona == '2' && mostrarFormulario"
        [title]="comunText['demandante-juridico']"
        [withSubmitButton]="false"
        (changeAction)="validarFormularioDemandante($event)"
        (changedControl)="onChangeValidarFormulario($event)"
        [idEntidad]="entidadId" />

      <div class="d-flex flex-wrap justify-content-end gap-2 mt-md-5 mt-3">
        <button
          type="submit"
          class="btn-govco fill-add-govco mt-3"
          [disabled]="formDemandante?.invalid"
          (click)="agregarDemandante(true,false)"
          [attr.aria-label]="sfcText['tramite-sic-comp-desleal']['guardar-demandante']">
          {{ sfcText['tramite-sic-comp-desleal']['guardar-demandante'] }}
        </button>
      </div>

      <app-table
        [estiloEncabezado]="'height: auto !important;'"
        *ngIf="dataTableNatural.length > 0"
        id="tblDemandanteNatural"
        [acciones]="actions"
        (eventoAccion)="accionesDemandante($event)"
        [datos]="dataTableNatural"
        [columnas]="columnsNatural"
        [paginacion]="false" />
      <br />
      <app-table
        [estiloEncabezado]="'height: auto !important;'"
        *ngIf="dataTableJuridica.length > 0"
        id="tblDemandanteJuridic"
        [acciones]="actions"
        (eventoAccion)="accionesDemandante($event)"
        [datos]="dataTableJuridica"
        [columnas]="columnsJuridica"
        [paginacion]="false" />
      <br />
    </div>

    <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
      <div class="d-flex flex-column flex-md-row gap-2">
        <button
          type="button"
          class="btn-govco fill-btn-govco w-auto"
          (click)="seguirConApoderado($event, true)"
          [attr.aria-label]="sfcText['botones-envio']['guardar-sin-enviar']">
          {{ sfcText['botones-envio']['guardar-sin-enviar'] }}
        </button>
        <button
          type="submit"
          class="btn-govco fill-next-btn-govco btn-form w-auto"
          (click)="onClickSiguiente($event, false)"
          [attr.aria-label]="sfcText['siguiente']">
          {{ sfcText['siguiente'] }}
        </button>
      </div>
    </div>
  </ng-container>
